import React from "react";

interface AddressPanelProps {
  children: React.ReactNode;
  className?: string;
}

export const AddressPanel: React.FC<AddressPanelProps> = ({ children, className = "" }) => {
  const classes = `address-panel ${className}`.trim();
  return <div className={classes}>{children}</div>;
};
